export default class Share {
    constructor() {
        this.init();
    }

    init() {
        let elements = document.querySelectorAll( '[data-share="element"]' );
        elements.forEach( ( element ) => {
            let trigger = element.querySelector( '[data-share="trigger"]' );
            trigger.addEventListener( 'click', ( e ) => {
                element.classList.toggle( 'share-active' );
            } );

            document.body.addEventListener( 'click', ( e ) => {
                if ( trigger.contains( e.target ) === false ) {
                    element.classList.remove( 'share-active' );
                }
            } );
        } );
    }
}